export const CHAT_ERROR_CODES = {
  CHAT_ATTACHMENT_EXTRACTION_EMPTY: 'CHAT_ATTACHMENT_EXTRACTION_EMPTY',
  CHAT_ATTACHMENT_EXTRACTION_FAILED: 'CHAT_ATTACHMENT_EXTRACTION_FAILED',
  CHAT_ATTACHMENT_NOT_FOUND: 'CHAT_ATTACHMENT_NOT_FOUND',
  CHAT_ATTACHMENT_PASSWORD_PROTECTED: 'CHAT_ATTACHMENT_PASSWORD_PROTECTED',
  CHAT_ATTACHMENT_3D_FORMAT_UNSUPPORTED: 'CHAT_ATTACHMENT_3D_FORMAT_UNSUPPORTED',
  CHAT_ATTACHMENT_UNREADABLE: 'CHAT_ATTACHMENT_UNREADABLE',
  CHAT_ATTACHMENT_LIMIT_EXCEEDED: 'CHAT_ATTACHMENT_LIMIT_EXCEEDED',
  CHAT_ATTACHMENT_PROCESSING_TIMEOUT: 'CHAT_ATTACHMENT_PROCESSING_TIMEOUT',
  CHAT_ATTACHMENT_NOT_READY: 'CHAT_ATTACHMENT_NOT_READY',
  CHAT_ATTACHMENT_TOO_LARGE: 'CHAT_ATTACHMENT_TOO_LARGE',
  CHAT_ATTACHMENT_TOO_MANY: 'CHAT_ATTACHMENT_TOO_MANY',
  CHAT_ATTACHMENT_UNSUPPORTED: 'CHAT_ATTACHMENT_UNSUPPORTED',
  CHAT_ATTACHMENT_UPLOAD_RATE_LIMIT: 'CHAT_ATTACHMENT_UPLOAD_RATE_LIMIT',
  CHAT_TURN_NOT_FOUND: 'CHAT_TURN_NOT_FOUND',
  CONVERSATION_NOT_FOUND: 'CONVERSATION_NOT_FOUND',
  DOCUMENT_DELETE_FAILED: 'DOCUMENT_DELETE_FAILED',
  DOCUMENT_DUPLICATE_NAME: 'DOCUMENT_DUPLICATE_NAME',
  DOCUMENT_REPLACE_FAILED: 'DOCUMENT_REPLACE_FAILED',
  DOCUMENT_REPLACE_FORBIDDEN: 'DOCUMENT_REPLACE_FORBIDDEN',
  DOCUMENT_EXPORT_ENGINE_UNAVAILABLE: 'DOCUMENT_EXPORT_ENGINE_UNAVAILABLE',
  DOCUMENT_EXPORT_FAILED: 'DOCUMENT_EXPORT_FAILED',
  DOCUMENT_EXPORT_FORMAT_UNSUPPORTED: 'DOCUMENT_EXPORT_FORMAT_UNSUPPORTED',
  DOCUMENT_EXPORT_NOT_FOUND: 'DOCUMENT_EXPORT_NOT_FOUND',
  DOCUMENT_FILE_UNAVAILABLE: 'DOCUMENT_FILE_UNAVAILABLE',
  DOCUMENT_ACCESS_DENIED: 'DOCUMENT_ACCESS_DENIED',
  DOCUMENT_RANGE_INVALID: 'DOCUMENT_RANGE_INVALID',
  DOCUMENT_REINDEX_NOT_ALLOWED: 'DOCUMENT_REINDEX_NOT_ALLOWED',
  DOCUMENT_INDEXING_FAILED: 'DOCUMENT_INDEXING_FAILED',
  DOCUMENT_UPLOAD_FAILED: 'DOCUMENT_UPLOAD_FAILED',
  INVALID_MESSAGE_ID: 'INVALID_MESSAGE_ID',
  LLM_RATE_LIMITED: 'LLM_RATE_LIMITED',
  MESSAGE_SEND_FAILED: 'MESSAGE_SEND_FAILED',
  TOOL_CONTINUATION_ALREADY_APPLIED: 'TOOL_CONTINUATION_ALREADY_APPLIED',
  TOOL_CONTINUATION_INVALID_TARGET: 'TOOL_CONTINUATION_INVALID_TARGET',
  TOOL_CONTINUATION_UNKNOWN_TOOL_CALL: 'TOOL_CONTINUATION_UNKNOWN_TOOL_CALL',
  PAGEINDEX_UNAVAILABLE: 'PAGEINDEX_UNAVAILABLE',
  QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
  RAG_DOCUMENT_NOT_INDEXED: 'RAG_DOCUMENT_NOT_INDEXED',
  RAG_ACL_STALE: 'RAG_ACL_STALE',
  RAG_EMBEDDING_FAILED: 'RAG_EMBEDDING_FAILED',
  RAG_ENGINE_UNAVAILABLE: 'RAG_ENGINE_UNAVAILABLE',
  RAG_HYBRID_RETRIEVAL_FAILED: 'RAG_HYBRID_RETRIEVAL_FAILED',
  RAG_INDEXING_EMPTY_CHUNKS: 'RAG_INDEXING_EMPTY_CHUNKS',
  RAG_LEGACY_CROSS_TENANT: 'RAG_LEGACY_CROSS_TENANT',
  RAG_LEGACY_DOC_IDS_UNRESOLVED: 'RAG_LEGACY_DOC_IDS_UNRESOLVED',
  RAG_NO_COMPANY: 'RAG_NO_COMPANY',
  RAG_NO_INDEXED_DOCUMENTS: 'RAG_NO_INDEXED_DOCUMENTS',
  RAG_PAYLOAD_AMBIGUOUS: 'RAG_PAYLOAD_AMBIGUOUS',
  RAG_PRINCIPALS_INVALID: 'RAG_PRINCIPALS_INVALID',
  RAG_PGVECTOR_UNSUPPORTED: 'RAG_PGVECTOR_UNSUPPORTED',
  RAG_RERANK_FAILED: 'RAG_RERANK_FAILED',
  // Staan (sole web search provider) cannot serve the search: typed reason in details.
  WEB_SEARCH_PROVIDER_UNAVAILABLE: 'WEB_SEARCH_PROVIDER_UNAVAILABLE',
  WEB_TOOLS_DISABLED: 'WEB_TOOLS_DISABLED',
  WEB_TOOLS_FETCH_BLOCKED: 'WEB_TOOLS_FETCH_BLOCKED',
  WEB_TOOLS_FETCH_EMPTY: 'WEB_TOOLS_FETCH_EMPTY',
  WEB_TOOLS_FETCH_FAILED: 'WEB_TOOLS_FETCH_FAILED',
  WEB_TOOLS_QUOTA_EXCEEDED: 'WEB_TOOLS_QUOTA_EXCEEDED',
  WEB_TOOLS_SEARCH_FAILED: 'WEB_TOOLS_SEARCH_FAILED',
  WEB_TOOLS_UNAVAILABLE: 'WEB_TOOLS_UNAVAILABLE',
  WEB_TOOLS_URL_INVALID: 'WEB_TOOLS_URL_INVALID',
  SELFHOSTED_LLM_NOT_CONFIGURED: 'SELFHOSTED_LLM_NOT_CONFIGURED',
  SELFHOSTED_LLM_UNAVAILABLE: 'SELFHOSTED_LLM_UNAVAILABLE',
} as const;

export const AUDIO_ERROR_CODES = {
  AUDIO_ANALYSIS_FAILED: 'AUDIO_ANALYSIS_FAILED',
  AUDIO_ATTACHMENT_BATCH_TOO_LONG: 'AUDIO_ATTACHMENT_BATCH_TOO_LONG',
  AUDIO_ATTACHMENT_TOO_LARGE: 'AUDIO_ATTACHMENT_TOO_LARGE',
  AUDIO_ATTACHMENT_TOO_LONG: 'AUDIO_ATTACHMENT_TOO_LONG',
  AUDIO_ATTACHMENT_TOO_MANY: 'AUDIO_ATTACHMENT_TOO_MANY',
  AUDIO_ATTACHMENT_UNSUPPORTED: 'AUDIO_ATTACHMENT_UNSUPPORTED',
  AUDIO_QUOTA_EXCEEDED: 'AUDIO_QUOTA_EXCEEDED',
  AUDIO_SERVICE_UNAVAILABLE: 'AUDIO_SERVICE_UNAVAILABLE',
  AUDIO_SOURCE_EXPIRED: 'AUDIO_SOURCE_EXPIRED',
  AUDIO_TRANSCRIPTION_CANCELED: 'AUDIO_TRANSCRIPTION_CANCELED',
  AUDIO_TRANSCRIPTION_DEAD: 'AUDIO_TRANSCRIPTION_DEAD',
  AUDIO_TRANSCRIPTION_DISABLED: 'AUDIO_TRANSCRIPTION_DISABLED',
  AUDIO_TRANSCRIPTION_FAILED: 'AUDIO_TRANSCRIPTION_FAILED',
  AUDIO_TRANSCRIPTION_NOT_FOUND: 'AUDIO_TRANSCRIPTION_NOT_FOUND',
  AUDIO_TRANSCRIPTION_NOT_RETRYABLE: 'AUDIO_TRANSCRIPTION_NOT_RETRYABLE',
  AUDIO_UPLOAD_INCOMPLETE: 'AUDIO_UPLOAD_INCOMPLETE',
  AUDIO_UPLOAD_NOT_FOUND: 'AUDIO_UPLOAD_NOT_FOUND',
  AUDIO_UPLOAD_VALIDATION_FAILED: 'AUDIO_UPLOAD_VALIDATION_FAILED',
} as const;

export const DOCGEN_ERROR_CODES = {
  DOCGEN_BRIEF_INVALID: 'DOCGEN_BRIEF_INVALID',
  DOCGEN_COMPLIANCE_FAILED: 'DOCGEN_COMPLIANCE_FAILED',
  DOCGEN_DISABLED: 'DOCGEN_DISABLED',
  DOCGEN_EXEC_FAILED: 'DOCGEN_EXEC_FAILED',
  DOCGEN_EDIT_INVALID: 'DOCGEN_EDIT_INVALID',
  DOCGEN_EXEC_TIMEOUT: 'DOCGEN_EXEC_TIMEOUT',
  DOCGEN_EXPORT_UNSUPPORTED: 'DOCGEN_EXPORT_UNSUPPORTED',
  DOCGEN_GENERATION_FAILED: 'DOCGEN_GENERATION_FAILED',
  DOCGEN_MODEL_INVALID: 'DOCGEN_MODEL_INVALID',
  DOCGEN_OUTPUT_TOO_LARGE: 'DOCGEN_OUTPUT_TOO_LARGE',
  DOCGEN_QUOTA_EXCEEDED: 'DOCGEN_QUOTA_EXCEEDED',
  DOCGEN_RENDER_FAILED: 'DOCGEN_RENDER_FAILED',
  DOCGEN_REVISION_CONFLICT: 'DOCGEN_REVISION_CONFLICT',
  DOCGEN_REVISION_TARGET_NOT_FOUND: 'DOCGEN_REVISION_TARGET_NOT_FOUND',
  DOCGEN_REVISION_UNSUPPORTED_LEGACY: 'DOCGEN_REVISION_UNSUPPORTED_LEGACY',
  DOCGEN_SERVICE_UNAVAILABLE: 'DOCGEN_SERVICE_UNAVAILABLE',
  // A text to place as is did not reach the document unchanged (truncated or altered).
  DOCGEN_SOURCE_FIDELITY_FAILED: 'DOCGEN_SOURCE_FIDELITY_FAILED',
  DOCGEN_UNSUPPORTED_KIND: 'DOCGEN_UNSUPPORTED_KIND',
  DOCGEN_VALIDATION_FAILED: 'DOCGEN_VALIDATION_FAILED',
} as const;

export const QUOTA_ERROR_CODES = {
  COMPANY_QUOTA_EXCEEDED: 'COMPANY_QUOTA_EXCEEDED',
  QUOTA_CONFIG_REQUIRED: 'QUOTA_CONFIG_REQUIRED',
  QUOTA_INVALID_RENEWAL_DATE: 'QUOTA_INVALID_RENEWAL_DATE',
  QUOTA_NOT_CONFIGURED: 'QUOTA_NOT_CONFIGURED',
} as const;

export const ORG_ERROR_CODES = {
  COMPANY_LOGO_IMAGE_INVALID: 'COMPANY_LOGO_IMAGE_INVALID',
  COMPANY_LOGO_IMAGE_TOO_LARGE: 'COMPANY_LOGO_IMAGE_TOO_LARGE',
  COMPANY_MEMBER_ALREADY_EXISTS: 'COMPANY_MEMBER_ALREADY_EXISTS',
  COMPANY_MEMBER_ALREADY_VERIFIED: 'COMPANY_MEMBER_ALREADY_VERIFIED',
  COMPANY_MEMBER_DISABLED: 'COMPANY_MEMBER_DISABLED',
  EMAIL_AVAILABILITY_RATE_LIMITED: 'EMAIL_AVAILABILITY_RATE_LIMITED',
  INVITATION_SEND_FAILED: 'INVITATION_SEND_FAILED',
  LAST_COMPANY_ADMIN: 'LAST_COMPANY_ADMIN',
  ORG_FORBIDDEN: 'ORG_FORBIDDEN',
  USER_CREATION_FAILED: 'FAILED_TO_CREATE_USER',
} as const;

export const KB_SOURCE_ERROR_CODES = {
  KB_SOURCE_NOT_FOUND: 'KB_SOURCE_NOT_FOUND',
  M365_CONSENT_DENIED: 'M365_CONSENT_DENIED',
  M365_CONSENT_REQUIRED: 'M365_CONSENT_REQUIRED',
  M365_CONSENT_STATE_INVALID: 'M365_CONSENT_STATE_INVALID',
  M365_CONSENT_TENANT_MISMATCH: 'M365_CONSENT_TENANT_MISMATCH',
  M365_CONNECTOR_DISABLED: 'M365_CONNECTOR_DISABLED',
  M365_ACL_UNRESOLVED: 'M365_ACL_UNRESOLVED',
  M365_GRAPH_CONSENT_REVOKED: 'M365_GRAPH_CONSENT_REVOKED',
  M365_GRAPH_FATAL: 'M365_GRAPH_FATAL',
  M365_GRAPH_THROTTLED: 'M365_GRAPH_THROTTLED',
  M365_GRAPH_TRANSIENT: 'M365_GRAPH_TRANSIENT',
  M365_DELTA_TOKEN_EXPIRED: 'M365_DELTA_TOKEN_EXPIRED',
  M365_DOWNLOAD_FAILED: 'M365_DOWNLOAD_FAILED',
  M365_SYNC_FAILED: 'M365_SYNC_FAILED',
  M365_SITE_GROUP_REFRESH_FAILED: 'M365_SITE_GROUP_REFRESH_FAILED',
  SOURCE_CAPACITY_EXCEEDED: 'SOURCE_CAPACITY_EXCEEDED',
  SOURCE_ACTION_INVALID_STATE: 'SOURCE_ACTION_INVALID_STATE',
  SOURCE_SITE_ACCESS_DENIED: 'SOURCE_SITE_ACCESS_DENIED',
  SOURCE_SITE_NO_DRIVES: 'SOURCE_SITE_NO_DRIVES',
  SOURCE_SITE_URL_INVALID: 'SOURCE_SITE_URL_INVALID',
  M365_TENANT_ALREADY_CONNECTED: 'M365_TENANT_ALREADY_CONNECTED',
  M365_WEBHOOK_INVALID: 'M365_WEBHOOK_INVALID',
} as const;

export const SETTINGS_ERROR_CODES = {
  SETTINGS_DOMAIN_UNKNOWN: 'SETTINGS_DOMAIN_UNKNOWN',
  SETTING_NOT_AVAILABLE: 'SETTING_NOT_AVAILABLE',
  SETTINGS_VALIDATION_FAILED: 'SETTINGS_VALIDATION_FAILED',
  SETTINGS_VERSION_CONFLICT: 'SETTINGS_VERSION_CONFLICT',
  SETTINGS_SCHEMA_TOO_RECENT: 'SETTINGS_SCHEMA_TOO_RECENT',
  SETTINGS_RATE_LIMITED: 'SETTINGS_RATE_LIMITED',
} as const;

export type ChatErrorCode = (typeof CHAT_ERROR_CODES)[keyof typeof CHAT_ERROR_CODES];
export type DocgenErrorCode = (typeof DOCGEN_ERROR_CODES)[keyof typeof DOCGEN_ERROR_CODES];
export type QuotaErrorCode = (typeof QUOTA_ERROR_CODES)[keyof typeof QUOTA_ERROR_CODES];
export type OrgErrorCode = (typeof ORG_ERROR_CODES)[keyof typeof ORG_ERROR_CODES];
export type KbSourceErrorCode = (typeof KB_SOURCE_ERROR_CODES)[keyof typeof KB_SOURCE_ERROR_CODES];
export type SettingsErrorCode = (typeof SETTINGS_ERROR_CODES)[keyof typeof SETTINGS_ERROR_CODES];
export type AudioErrorCode = (typeof AUDIO_ERROR_CODES)[keyof typeof AUDIO_ERROR_CODES];
